<template>
  <button @click="addC">Add C</button>
</template>

<script>
export default {
    methods: {
        addC(){
            this.$emit('add-sym','c')
        }
    },
}
</script>

<style>

</style>